//import axios from 'axios';
import ajax from "@/sy/app.ajax.js";
let http =
{
    hello: function()
    {
        console.log("Hello: sy.http");
        // 使用案例
        // let $_this = this;
        // sy.http.get(
        // {
        //     url: this.$root.API + '',
        //     data:
        //     {
        //     },
        //     success: function(res)
        //     {
        //     }
        // });
    },

    // 封装过的方法 拦截401 会跳去 微信拿 code 或者 非微信环境 跳去登录页
    get: function(obj)
    {
        let $_this = this;
        if( obj.data === undefined )
        {
            obj.data = {};
        }
        obj.data.utoken = localStorage.getItem('utoken');
        ajax.get({
                url:  obj.url,
                data: obj.data,
                success: function(res)
                {
                    if( res.state === "401" )
                    {
						//  // 跳去微信登录
						if( $_this.is_wechat() )
						{
							// 测试getCode是否可以搞  做一个中专服务器试试
							// this.getCode(); //看看401的时候 会不会 显示当前页面内容
							// location.href = '/auth/wechat'; //当前页面信息 可以打包一下

							let Base64 = require("js-base64").Base64;
							let pageto = Base64.encode(location.href);

							location.href = "/auth/wechat?pageto=" + pageto;
						}else{
							//location.href = "/auth/phone?pageto=" + pageto;

                            // let con = confirm('即将跳去登录页');
                            // if( con )
                            // {
                            //     location.href = "/auth/phone";
                            // }else{
                            //     console.log('用户取消了登录');
                            //     return false;
                            // }

                            alert('即将跳去登录页');
                            location.href = "/auth/login";
						}
                    }else{
                        obj.success(res);
                    }
                }
            }
        );

        // return new Promise((resolve, reject) => {
        //     axios.get(
        //         obj.url,
        //         {
        //             params: obj.data,
        //         }
        //     ).then(function(response){
        //         //console.log(response);
        //         resolve(obj.success(response.data))
        //     }).catch(err => {
        //         console.log(err);
        //         reject(err);
        //     })
        // });
        // return new Promise((resolve, reject) => {
        //     axios.get(
        //         obj.url,
        //         {
        //             params: obj.data,
        //         }
        //     ).then(function(response){
        //         //console.log(response);
        //         let res = response.data;
        //         if( res.state == "401" )
        //         {
        //             http.getCode();
        //         }else{
        //             resolve(obj.success(response.data))
        //         }

        //     }).catch(err => {
        //         console.log(err);
        //         reject(err);
        //     })
        // });
    },
	getSearch: function( tag )
	{
		var urls   = {};
		var search = {};

		if( location.search !== "" )
		{
			search = location.search.replace('?', '').split('&');
		}

		for( var k in search )
		{
			var s = search[k].split('=');
			urls[s[0]] = s[1];
		}
		// console.log( urls );

		if( tag !== undefined )
		{
			if( urls[tag] === undefined )
			{
				return false;
			}
			return urls[tag];
		}
		return urls;
	},

    // 同步只有首次会进  异步 401 拿了code必须跳转去微信登录页处理
    getCode: function(pageto=undefined)
    {
        // 参数整理 pageto 页内传参
        let appid = 'wx79d9e3502d1451de';

        // 若非跳转过来的 比如 异步 401 则使用请求页面 呼应那个疑问
        if( pageto === undefined )
        {
			let Base64 = require('js-base64').Base64
            pageto = Base64.encode(location.href)
        }

        // 回调请求 url_origin 什么时候会不存在???
        let url_origin = location.origin;
        if( url_origin === undefined )
        {
            url_origin = 'https://m.humall2026.cn';
        }
        let url_login = encodeURIComponent( url_origin + '/auth/wechat?to=' + pageto);

        // 最终请求
        let url_wx = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + url_login + '&response_type=code&scope=snsapi_base&state=state#wechat_redirect';
        location.href = url_wx;
    },

    // get 请求 专用方法 不能拦截 微信回调专用？  就算不用呢  会咋样
    // getAuth: function(obj)
    // {
    //     if( obj.data === undefined )
    //     {
    //         obj.data = {};
    //     }
    //     ajax.get({
    //             url:  obj.url,
    //             data: obj.data,
    //             success: function(res)
    //             {
    //                 obj.success(res)
    //             }
    //         }
    //     );
    // },

	is_wechat: function()
	{
		var ua = window.navigator.userAgent.toLowerCase();
		if (ua.match(/MicroMessenger/i) == 'micromessenger')
		{
			return true;
		} else {
			return false;
		}
	},

};

export default http;